// @flow

import React, { type Node } from 'react';
import styled, { css } from 'styled-components';
import { useIsMobile } from '@tectonics/hooks';

type TipModel = {
  imgSrc: string,
  tipText: Node,
  altText: string,
}

type TipsBoxProps = {
  title: string,
  tipsModel: ImmutableArray<TipModel>,
}

export function TipsBox({ title, tipsModel }: TipsBoxProps): Node {
  const isMobile = useIsMobile();

  return (
    <TipsCard>
      <TipsTitle>{title}</TipsTitle>
      {tipsModel.map(
        ({imgSrc, tipText, altText}, index) => {
          return (
            <Tip key={index} maxWidth={isMobile ? '100%' : '319px'}>
              <TipIcon src={imgSrc} alt={altText}/>
              <TipText>
                {tipText}
              </TipText>
            </Tip>
          );
        }
      )}
    </TipsCard>
  );
}


const TipsCard = styled.div`
  background: #f8f8f9;
  border-radius: 5px;
  padding: 19px 14px 21px 14px;
`;

const TipsTitle = styled.h1`
  margin-bottom: 15px;
  color: #738093;
  font-family: ${props => props.theme.fontFamily.display};
  font-weight: 500;
  font-size: 18px;
  text-align: center;
`;

const Tip = styled.div`
  ${({ maxWidth }) => maxWidth && css`
    max-width: ${maxWidth};
  `}
  display: flex;
  margin: 15px auto;
  align-items: center;
`;

const TipIcon = styled.img`
  flex: 0 0 auto;
  height: 100%;
`;

const TipText = styled.div`
  color: #4e5765;
  font-size: 14px;
  margin-left: 8px;
`;
